export default function({ app, redirect, store, route }) {
  const hasToken = !!app.$apolloHelpers.getToken();

  if (!hasToken) {
    const fullPath = route.fullPath;

    return redirect(`/log-in?redirect=${fullPath}`);
  } else if (
    ['MODERATOR', 'ADMIN', 'SUPER_ADMIN'].includes(store.state.role) &&
    !store.state.masquerading
  ) {
    if (!route.path.includes('/log-in')) {
      return redirect('/admin/submissions');
    }
  }
}
